// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixWindow from 'wix-window';

$w.onReady(function () {
	// Write your JavaScript here

	// To select an element by ID use: $w('#elementID')

	// Click 'Preview' to run your code
});


/**
*	Adds an event handler that runs when the element is clicked.
	[Read more](https://www.wix.com/corvid/reference/$w.ClickableMixin.html#onClick)
*	 @param {$w.MouseEvent} event
*/
export function signInButton_click(event) {
	    // wixWindow.trackEvent("CustomEvent", {
		// 	"event": "Test Button Clicked",
		// 	"eventCategory": "Test Button",
		// 	"eventAction": "click",
		// 	"eventLabel": "Test Button"
		// });
	// console.log($w('#signInButton').window)
	// Google Ads conversion event for sign ups
}